(function($) {

var pageId = 'page-member',
  page = '#' + pageId;

$(function() {
  $( document )
  .on("boxChanged todocomplete todoremove", page, function () {
    tower.memberTodosFilter()
  })
  .on( "todoupdate", page, function( e, oldTodo, oldList, newTodo, newList ) {
    var newAssigneeGuid = newTodo.find('.assignee').data('guid'),
      newAssigneeDate = newTodo.find('.due').data('date'),
      memberGuid = $(page).data('guid'),
      expandedTodo = newTodo.closest('.expanded-todo');

    if (newAssigneeGuid === memberGuid) {
      expandedTodo.removeClass('participant');
    } else if (expandedTodo.find('.check-item, .check-item-form').length > 0) {
      expandedTodo.addClass('participant')
    } else {
      newTodo.find('.label.todo-assign-due').addClass('disabled');

      setTimeout(function() {
        expandedTodo.fadeOut(function() {
          expandedTodo.remove();
          $( ".workspace .page:last .page-inner" ).trigger('todoremove', [newTodo, newList, null, null]);
        });
      }, 1000);
    }

    newAssigneeDate = newAssigneeDate ? moment(newAssigneeDate).unix() : 9999999999
    expandedTodo.data('due-at', newAssigneeDate)
    expandedTodo.attr('data-due-at', newAssigneeDate)
    tower.memberTodosFilter()
  });
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
  if ($page.data('self')) {
    $('#nav-me').addClass('active');
  } else {
    $('#nav-members').addClass('active');
  }

  tower.memberTodosInit();
  tower.adjustTodo();
  tower.workStatus();
});
})(jQuery);
